import React, { useState, useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Button } from "primereact/button";
import { Toast } from "primereact/toast";
import { setUser, clearUser } from "../Redux/userSlice";
import { persistor } from "../Redux/store";
import Logo from "../assets/Images/Logo.png";
import "./navbar.css";
import { useNavigate } from "react-router-dom";
import { apiService } from "../services/apiService"; // Adjust the import path

const Navbar = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const toast = useRef(null);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const user = useSelector((state) => state.user);
  const credits = user?.credits || 0;

  // Fetch credits when component mounts or user.email changes
  useEffect(() => {
    const fetchCredits = async () => {
      if (user.email) {
        try {
          const response = await apiService.getCredits(user.email);
          dispatch(setUser({ credits: response.body.credits }));
        } catch (error) {
          console.error("Failed to fetch credits:", error);
          toast.current.show({
            severity: 'error',
            summary: 'Error',
            detail: 'Failed to fetch credits. Please try again later.',
            life: 3000,
          });
        }
      }
    };

    fetchCredits();
  }, [user.email, dispatch]);

  const showToast = (severity, summary, detail) => {
    toast.current.show({ severity, summary, detail, life: 3000 });
  };

  const handleLogout = () => {
    dispatch(clearUser());
    persistor.purge();
    localStorage.removeItem("access_token");
    showToast('info', 'Logged Out', 'You have been logged out successfully.');
    window.location.href = "/";
  };

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  const handleDashboard = () => {
    navigate("/landing");
  };

  const handleBuyCredits = () => {
    navigate("/pricing");
  };

  return (
    <div className="navbar">
      <Toast ref={toast} />
      <div className="navbar-container">
        {/* Logo */}
        <div className="logo">
          <img
            src={Logo}
            onClick={() => navigate("/landing")}
            alt="logo"
            className="logo-image"
          />
        </div>

        {/* Hamburger icon for mobile */}
        <div className="mobile-menu-toggle" onClick={toggleMobileMenu}>
          <i className={`pi ${mobileMenuOpen ? "pi-times" : "pi-bars"}`}></i>
        </div>

        {/* Right-side nav items */}
        <div className={`nav-options ${mobileMenuOpen ? "mobile-menu-active" : ""}`}>
          <span className="nav-link" onClick={() => navigate("/landing")}>
            Home
          </span>
          <span className="nav-link" onClick={() => navigate("/pricing")}>
            Pricing
          </span>
          <span className="nav-link" onClick={() => navigate("/my-scans")}>
            My Scans
          </span>

          {/* Credit Display */}
          <span className="nav-link credits-display">
            <i className="pi pi-wallet" style={{ marginRight: "5px" }}></i>
            Credits: <strong>{credits}</strong>
          </span>

          {/* Buy Credits */}
          {/* <Button
            label="Buy Credits"
            icon="pi pi-credit-card"
            className="nav-btn nav-credit"
            onClick={handleBuyCredits}
          /> */}

          {/* Dashboard */}
          {/* <Button
            label="Dashboard"
            icon="pi pi-home"
            className="nav-btn nav-dashboard"
            onClick={handleDashboard}
          /> */}

          {/* Logout */}
          <Button 
            label="Logout" 
            // icon="pi pi-sign-out" 
            className="nav-btn nav-logout" 
            onClick={handleLogout} 
          />
        </div>
      </div>
    </div>
  );
};

export default Navbar;